import React, { Component } from 'react';
import {c_shade_places as colors} from '../a-Graphic/Colors';
import {p_size_1, p_size_2, p_size_3} from '../a-Graphic/Layout';

import getMyMap, {createNamesLayer, createResidentialAreasMassLayer, createCommuneBordersLayer,
  getLegend, createAreasMassLayer} from '../b-LeafletMap/leaflet_map';

import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';

class Destinations extends React.Component {

  componentDidMount() {

    /* COMMUNES */
    var communes = this.props.territory.communes;
    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    /* RESIDENTIAL */
    var residential_areas = [];
    this.props.territory.communes.map((c) => residential_areas = residential_areas.concat(c.residential_areas));
    var ra_population = residential_areas.map((ra) => ra.population)
    var ra_labels = residential_areas.map((ra)=> ra.name + " - " + ra.population + " hab")

    /* MOBILITY */
    var destinations = this.props.territory.all_travels.destinations
    destinations = destinations.filter((d)=>d.mass>0.01)
    var destinations_coords = destinations.map((c) => c.center);
    var destinations_masses = destinations.map((c) => c.mass*1000);
    var destinations_labels = destinations.map((c) => '<span class="small-text">' + c.name + "</span></br>" + Math.round(c.mass*100) +"%");

    // --- init map
    var mymap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    var communes_layer = createCommuneBordersLayer(mymap, communes)
    createResidentialAreasMassLayer(mymap, residential_areas, null, ra_labels);
    //createResidentialAreasWhiteZoneLayer(mymap, residential_areas, doctors_coords, distances);
    var areas_layer = createAreasMassLayer(mymap, destinations_coords, destinations_masses);
    createNamesLayer(mymap, destinations_coords, destinations_labels);

    // --- center the map
    areas_layer.addLayer(communes_layer)
    mymap.fitBounds(areas_layer.getBounds());
  }


  render() {
    return(
      <div className="row content mt-4 mb-5">
        <div className="col-12">

          <div className="row">
            <div className="col-12">
              <h3 className="mb-3">destinations - tous motifs confondus</h3>
            </div>
          </div>

          <div className="row align-items-end">
            <div className="col-9">
              <div style={{height: "600px"}} id={this.props.id}></div>
            </div>
            <div className="col-3">
                 <LegendResidentialArea label="" grey={true}/>
                 <div className="mt-3 mb-3"></div>
                 <LegendClusterArea label="Communes de destination" sublabel="part des déplacements vers la commune"/>
            </div>
          </div>

        </div>
      </div>
    )
  }
}

export default Destinations;
